import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'antd'
import { getSourceLabel } from '../../helpers/history'

const SWIPE_THRESHOLD = 50

// Popup xem ảnh lệnh may (không toàn màn hình): Trước/Sau, phím ← →, vuốt; Esc / ✕ / bấm ra ngoài để đóng.
// Nút Xoay chỉ xoay để xem (không lưu); đổi ảnh hoặc đóng/mở lại thì về chiều gốc.
const HandoverImageModal = ({ batches, index, subtitle, onIndexChange, onClose }) => {
    const visible = index >= 0 && index < batches.length
    const batch = visible ? batches[index] : null
    const touchStartX = useRef(null)
    const [broken, setBroken] = useState(false)
    const [rotation, setRotation] = useState(0)

    useEffect(() => {
        setBroken(false)
        setRotation(0)
    }, [index])

    const _step = (delta) => {
        const next = index + delta
        if (next < 0 || next >= batches.length) return
        onIndexChange(next)
    }

    useEffect(() => {
        if (!visible) return undefined

        const _onKeyDown = (e) => {
            if (e.key === 'ArrowLeft') _step(-1)
            else if (e.key === 'ArrowRight') _step(1)
        }

        window.addEventListener('keydown', _onKeyDown)
        return () => window.removeEventListener('keydown', _onKeyDown)
        // eslint-disable-next-line
    }, [visible, index, batches.length])

    const _onTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX
    }

    const _onTouchEnd = (e) => {
        if (touchStartX.current === null) return
        const dx = e.changedTouches[0].clientX - touchStartX.current
        if (Math.abs(dx) > SWIPE_THRESHOLD) _step(dx < 0 ? 1 : -1)
        touchStartX.current = null
    }

    if (!batch) return null

    const title = (
        <div className='HandoverImageModal__title'>
            <b>Lô {batch.name} · {batch.sku || '—'} · {batch.quantity} item</b>
            <small>{subtitle} · Nguồn: {getSourceLabel(batch)}</small>
        </div>
    )

    const hasImage = !batch.image_expired && !!batch.image_url && !broken
    // Xoay 90/270 thì chiều rộng/cao hiển thị đổi chỗ -> CSS đổi giới hạn kích thước ảnh
    const isQuarter = rotation % 180 !== 0

    const footer = (
        <div className='HandoverImageModal__footer'>
            <span>Ảnh {index + 1} / {batches.length} · phím ← → hoặc vuốt để chuyển · bấm Xoay nếu ảnh bị ngang</span>
            <span>
                <Button icon='redo' disabled={!hasImage} onClick={() => setRotation(value => (value + 90) % 360)}>Xoay</Button>
                <Button disabled={index === 0} onClick={() => _step(-1)}>‹ Trước</Button>
                <Button disabled={index === batches.length - 1} onClick={() => _step(1)}>Sau ›</Button>
            </span>
        </div>
    )

    const _renderImage = () => {
        if (batch.image_expired) return <div className='HandoverImageModal__empty'>Ảnh đã hết hạn lưu</div>
        if (!batch.image_url) return <div className='HandoverImageModal__empty'>Không có ảnh</div>
        if (broken) return <div className='HandoverImageModal__empty'>Không tải được ảnh</div>

        return (
            <img
                src={batch.image_url}
                alt={`Lệnh may lô ${batch.name}`}
                style={{ transform: `rotate(${rotation}deg)` }}
                onError={() => setBroken(true)}
            />
        )
    }

    return (
        <Modal
            className='HandoverImageModal'
            visible
            centered
            width={720}
            title={title}
            footer={footer}
            onCancel={onClose}
        >
            <div
                className={`HandoverImageModal__body${isQuarter ? ' is-quarter' : ''}`}
                onTouchStart={_onTouchStart} onTouchEnd={_onTouchEnd}>
                {_renderImage()}
            </div>
        </Modal>
    )
}

HandoverImageModal.propTypes = {
    batches: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    subtitle: PropTypes.string,
    onIndexChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default HandoverImageModal
